import jwtAuthAxios from './auth/jwtAuth';

const organizationServices = {
  update: async (organizationParams) => {
    const { data } = await jwtAuthAxios.put(`/v1/organizations/${organizationParams.id}`, organizationParams.data);
    return data;
  },
};

export default organizationServices;
